module.exports = __webpack_public_path__ + "img/oido1.063a51e8.jpg";